import React, { useCallback } from 'react';
import { GradientDiv, CardContainer, SectionDiv, HeaderSection, ProjectDetails, ProjectTitle } from './styles';
import ProjectIconAvatar from '../../../../../component/projectIconAvatar';
import { ICON_COLORS, ICON_SIZE, PROJECT_ICON_TYPE } from '../../../../../global/constants';
import { rootStore } from '../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import { SVGIconDiv } from '../../../../../component/viewCard/styles';
import TaskListView from '../../../../../component/templateTaskView';
import RightSectionLoading from './rightSectionLoading';
import { isEmpty } from '../../../../../helpers/common';

interface Props {
  currentStep: number;
}

const RightSection: React.FC<Props> = ({ currentStep }) => {
  const { projectStore } = rootStore;
  const { createProjectInput } = projectStore;

  const getProjectName = useCallback(() => {
    if (!isEmpty(createProjectInput?.name)) return createProjectInput?.name;
    else if (!isEmpty(createProjectInput?.selectedTemplate?.name)) return createProjectInput?.selectedTemplate?.name;
    else return '';
  }, [createProjectInput?.name, createProjectInput?.selectedTemplate?.name]);

  return (
    <SectionDiv className='desktop-create-project-right-section'>
      <GradientDiv className='desktop-create-project-right-section-gradient' />
      <CardContainer>
        <HeaderSection>
          <ProjectDetails>
            {createProjectInput?.icon ? (
              <ProjectIconAvatar
                size={36}
                type={createProjectInput?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
                reference={createProjectInput?.icon?.reference || ''}
                backgroundColor={createProjectInput?.icon?.color ? ICON_COLORS[createProjectInput?.icon?.color] : ''}
                projectName={getProjectName() || ''}
                iconSize={20}
              />
            ) : (
              <SVGIconDiv>
                <SVGIcon
                  name='pie-chart-icon'
                  width={ICON_SIZE.XL}
                  height={ICON_SIZE.XL}
                  viewBox={`0 0 ${ICON_SIZE.SM} ${ICON_SIZE.SM}`}
                  fill='var(--text-muted)'
                />
              </SVGIconDiv>
            )}

            {/* passed static name for now */}
            <ProjectTitle>{createProjectInput?.name || createProjectInput?.selectedTemplate?.name}</ProjectTitle>
          </ProjectDetails>
          {/* Hided the tabs */}

          {/* {!createProjectInput?.templateId &&
            currentStep !== CREATE_PROJECT_STEP.SELECT_TEMPLATE &&
            currentStep !== CREATE_PROJECT_STEP.TEMPLATE_PREVIEW && (
              <TabSection>
                <TabItem />
                <TabItem />
                <TabItem />
                <TabItem />
              </TabSection>
            )} */}
        </HeaderSection>
        {!createProjectInput?.templateId && <RightSectionLoading />}
        {createProjectInput?.templateId && <TaskListView />}
      </CardContainer>
    </SectionDiv>
  );
};

export default observer(RightSection);
